// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__paW3D","dadosWrapper":"styles_dadosWrapper__66zMz","text":"styles_text__e4l8w","value":"styles_value__7pIZP"};